import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {MarcacaoModel} from "../../models/marcacao.model";
import {SharedMarcacaoService} from "../../services/shared-marcacao.service";
import {Cid10Model} from "../../models/cid10.model";
import {Cid10Service} from "../../services/cid10.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-cabecalho',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss']
})
export class CabecalhoComponent {
  public atendimentoAtual: MarcacaoModel | undefined;
  codigoCid: string = '';
  codigosCid: Cid10Model[] = [];

  constructor(private modalService: NgbModal,
              private sharedMarcacaoService: SharedMarcacaoService,
              private cid10Service: Cid10Service,
             private toastrService: ToastrService) {
    this.sharedMarcacaoService.marcacaoAtual.subscribe((res) => {
      this.atendimentoAtual = res;
    });
  }

  abrirModal(content: any) {

    if (!this.codigoCid || this.codigoCid.trim() === '') {        
          this.toastrService.warning('Por favor, digite o código do CID.', 'Atenção');       
        return;
    }
    this.cid10Service.getByCid10(this.codigoCid).subscribe((res) => {
      this.codigosCid = res.data;
      this.modalService.open(content, { centered: false, windowClass: 'full-screen-modal', backdrop: 'static' });
    });
  }

  selecionarCid(cid: Cid10Model) {
    this.codigoCid = cid.cid_10;
    if (this.atendimentoAtual != null) {
      this.atendimentoAtual.seq_Cid = cid.seq_Cid;
      this.atendimentoAtual.cid10 = cid;
    }
  }
}
